if (!customElements.get('l-section-how-to-use')) {
	customElements.define(
		'l-section-how-to-use',
		class LTASectionHowToUse extends HTMLElement {
			constructor() {
				super()
			}

			connectedCallback() {
				// Elements
				this.stepLabelEls = this.querySelectorAll('[data-step-label]')
				this.stepContentEls = this.querySelectorAll('[data-step-content]')

				// Set up events
				const debounceScrollHandler = debounce((event) => {
					this.scrollHandler(event)
				}, 20)

				window.addEventListener('scroll', debounceScrollHandler)
			}

			scrollHandler(event) {
				let visibleIndex = -1
				let isScrollingDown = this.lastScrollTop < window.scrollY
				this.lastScrollTop = window.scrollY

				this.stepContentEls.forEach((contentEl, index) => {
					const rect = contentEl.getBoundingClientRect()

					const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight

					if (isVisible && visibleIndex === -1) {
						visibleIndex = index
					}
				})

				if (visibleIndex !== -1) {
					if (isScrollingDown) {
						this.stepLabelEls.forEach((labelEl, index) => {
							labelEl.classList.toggle('is-current', index === visibleIndex)
						})
					} else {
						this.stepLabelEls.forEach((labelEl, index) => {
							labelEl.classList.toggle('is-current', index === visibleIndex)
						})
					}
				}
			}
		}
	)
}

